import {Tooltip} from "rsuite";
import moment from "moment";

export const getTimezone = (deviceData) => {
  if (!deviceData?.time) return 'UTC+3';

  const date = new Date(deviceData.time);
  const timezoneOffset = -date.getTimezoneOffset() / 60;
  return `UTC${timezoneOffset >= 0 ? '+' : ''}${timezoneOffset}`;
};

export const formatTimeWithoutSeconds = (timeString) => {
  if (!timeString) return '00:00';

  if (typeof timeString === 'string') {
    return timeString.slice(0, 5);
  }

  const timeMoment = moment(timeString);

  if (timeMoment.isValid()) {
    return timeMoment.format('HH:mm');
  }

  return String(timeString).slice(0, 5);
};

export const getVoltageStyle = (voltage) => {
  return voltage > 0 ? { background: "#ed6f6b" } : { background: 'none' };
}

export const delayTooltip = (
  <Tooltip>Значение от 0.1 до 25.5 (шаг 0.1)</Tooltip>
);

export const fadeTooltip = (
  <Tooltip>Значение от 0 до 255 (шаг 1)</Tooltip>
);

export const prepareTimeData = (dateTime, timezoneInput) => {
  const timezone = parseTimezone(timezoneInput);

  const m = moment(dateTime);
  const timezoneOffset = timezone >= 0 ? `+${String(timezone).padStart(2, '0')}` : `-${String(Math.abs(timezone)).padStart(2, '0')}`;

  const timeWithTimezone = m.format(`YYYY-MM-DDTHH:mm:ss[${timezoneOffset}:00]`);

  return {
    time: timeWithTimezone
  };
};

export const parseTimezone = (timezoneInput) => {
  if (!timezoneInput) return 3;

  const match = timezoneInput.toString().match(/UTC\s*([+-]?\d+)/) ||
    timezoneInput.toString().match(/^([+-]?\d+)$/);

  if (match) {
    return parseInt(match[1], 10);
  }

  return 3;
};

export const extractTimezoneFromISO = (isoString) => {
  if (!isoString) return '+3';

  const match = isoString.match(/[+-]\d{2}:\d{2}$/);
  if (match) {
    const timezonePart = match[0];
    const hours = parseInt(timezonePart.slice(0, 3));
    return hours >= 0 ? `+${Math.abs(hours)}` : `-${Math.abs(hours)}`;
  }

  return '+3';
};

export const parseTimeWithMoment = (isoString) => {
  if (!isoString) return null;
  return moment(isoString).toDate();
};

export const gpsStatus = {
  actual: 'Actual',
  notActual: 'NotActual',
  none: 'None',
}


export const setStatus = (status) => {
  if (status === gpsStatus.actual) {
    return 'Данные актуальны'
  }
  if (status === gpsStatus.notActual) {
    return 'Данные не актуальны'
  }
  if (status === gpsStatus.none) {
    return 'Нет данных с приёмника'
  }
  return ''
}
